import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (measurementId && measurementId !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(measurementId);
    console.log('Google Analytics initialized with ID:', measurementId);
  } else {
    console.warn('Google Analytics not initialized: Please add your Measurement ID in App.js');
  }
};

// Track page views
export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
};

// Track custom events
export const logEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

// Track company interactions
export const logCompanyClick = (companyName) => {
  ReactGA.event({
    category: 'User Interaction',
    action: 'Clicked Company',
    label: companyName,
  });
};

// Track search queries
export const logSearch = (searchTerm) => {
  ReactGA.event({
    category: 'Search',
    action: 'Searched',
    label: searchTerm,
  });
};

// Track filter changes
export const logFilterChange = (filterType, filterValue) => {
  ReactGA.event({
    category: 'Filter',
    action: filterType,
    label: filterValue,
  });
};

// Track sort changes
export const logSortChange = (sortType) => {
  ReactGA.event({
    category: 'Sort',
    action: 'Changed Sort',
    label: sortType,
  });
};

// Track stats toggle
export const logStatsToggle = (isVisible) => {
  ReactGA.event({
    category: 'UI Interaction',
    action: 'Toggle Stats',
    label: isVisible ? 'Opened' : 'Closed',
  });
};

// Track changelog interactions
export const logChangeLogOpen = () => {
  ReactGA.event({
    category: 'UI Interaction',
    action: 'Opened Change Log',
    label: 'Change Log Dialog',
  });
};

// Track banner close
export const logBannerClose = () => {
  ReactGA.event({
    category: 'UI Interaction',
    action: 'Closed Banner',
    label: 'Info Banner',
  });
};

// Track suggestion box usage
export const logSuggestionButtonClick = () => {
  ReactGA.event({
    category: 'User Engagement',
    action: 'Clicked Suggest Button',
    label: 'Suggestion Box Opened',
  });
};

export const logSuggestionSubmit = () => {
  ReactGA.event({
    category: 'User Engagement',
    action: 'Submitted Suggestion',
    label: 'Suggestion Box',
  });
};
